import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string | ReactNode;
  description?: string;
  children: ReactNode;
  maxWidth?: string;
}

export const CustomModal = ({ 
  isOpen, 
  onClose, 
  title, 
  description, 
  children,
  maxWidth = "max-w-lg"
}: CustomModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      role="presentation"
      className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[100]"
      onClick={onClose}
    >
      <div 
        className={`fixed left-[50%] top-[50%] z-[100] grid w-full ${maxWidth} translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 sm:rounded-lg`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col space-y-1.5 text-center sm:text-left">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-foreground">
                {title}
              </h2>
              {description && (
                <p className="text-sm text-muted-foreground mt-1">
                  {description}
                </p>
              )}
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

